import React, { useEffect } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useMediaQuery,
  Card,
  CardContent,
  Grid,
  Typography,
  Chip,
  Divider,
  Button,
} from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import { Search, ArrowUpward, ArrowDownward } from "@mui/icons-material";
import PaginationControls from "./PaginationControls";
import { useNavigate } from "react-router-dom";

const OverviewTab = ({
  country,
  searchTerm,
  setSearchTerm,
  // filteredData,
  currentCountryData,
  sortBy,
  handleSort,
  getChangeColor,
  getChangeIcon,
  currencySymbols,
  page,
  setPage,
  entriesPerPage = 20,
  isLoggedIn,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  // console.log("Data in Overview:", currentCountryData);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Helper to get currency symbol
  // const getCurrencySymbol = (row) => {
  //   if (country === "Global") return currencySymbols["USD"] || "$";
  //   return currencySymbols[row.currency] || row.currency || "$";
  // };

  const filteredData =
    currentCountryData.overview?.filter((item) =>
      item.metal.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  // Calculate paginated data
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const paginatedData = filteredData.slice(
    (page - 1) * entriesPerPage,
    page * entriesPerPage
  );

  const handleLogin = () => {
    navigate("/login");
  };

  const handleRegister = () => {
    navigate("/register");
  };

  // console.log("filteredData:", filteredData);

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          filter: !isLoggedIn ? "blur(4px)" : "none",
          pointerEvents: !isLoggedIn ? "none" : "auto",
        }}
      >
        {/* Search */}
        <TextField
          fullWidth
          placeholder="Search materials..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{
            mb: 3,
            maxWidth: 400,
            "& .MuiOutlinedInput-root": {
              borderRadius: 3,
              backgroundColor: alpha(theme.palette.primary.main, 0.02),
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search color="action" />
              </InputAdornment>
            ),
          }}
        />

        {/* Market Table */}
        {/* {!isMobile ? (
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              borderRadius: 3,
              border: `1px solid ${theme.palette.divider}`,
              backgroundColor: alpha(theme.palette.background.paper, 0.7),
            }}
          >
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: alpha(theme.palette.primary.main, 0.05),
                  }}
                >
                  {[
                    { field: "material", label: "Material" },
                    {
                      field: "price",
                      label: `Price (${filteredData[0]?.currency} / ${filteredData[0]?.unit})`,
                    },
                    { field: "change", label: "Change (%)" },
                    { field: "volume", label: "Volume" },
                    {
                      field: "marketCap",
                      label: `Market Cap (${filteredData[0]?.currency})`,
                    },
                  ].map((column) => (
                    <TableCell
                      key={column.field}
                      sx={{
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: "0.95rem",
                        "&:hover": {
                          backgroundColor: alpha(
                            theme.palette.primary.main,
                            0.1
                          ),
                        },
                      }}
                      onClick={() => handleSort(column.field)}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {column.label}
                        {sortBy.field === column.field &&
                          (sortBy.direction === "asc" ? (
                            <ArrowUpward sx={{ fontSize: 18 }} />
                          ) : (
                            <ArrowDownward sx={{ fontSize: 18 }} />
                          ))}
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((row, i) => (
                    <TableRow
                      key={i}
                      sx={{
                        "&:hover": {
                          backgroundColor: alpha(
                            theme.palette.action.hover,
                            0.5
                          ),
                        },
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      <TableCell
                        sx={{ fontWeight: "medium", fontSize: "1rem" }}
                      >
                        {row.metal}
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                        {row.price}
                      </TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          icon={getChangeIcon(row.change_percent)}
                          label={row.change_percent}
                          sx={{
                            backgroundColor: alpha(
                              getChangeColor(row.change_percent),
                              0.1
                            ),
                            color: getChangeColor(row.change_percent),
                            fontWeight: "bold",
                            border: `1px solid ${alpha(
                              getChangeColor(row.change_percent),
                              0.3
                            )}`,
                          }}
                        />
                      </TableCell>
                      <TableCell sx={{ color: "text.secondary" }}>
                        {row.volume}
                      </TableCell>
                      <TableCell sx={{ fontWeight: "medium" }}>
                        {row.market_cap}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      sx={{
                        textAlign: "center",
                        py: 4,
                        color: theme.palette.text.secondary,
                        fontStyle: "italic",
                      }}
                    >
                      No market data available for this country.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          // Mobile Card Layout
          <Grid container spacing={2}>
            {paginatedData.map((row, i) => (
              <Grid item xs={12} key={i}>
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: theme.shadows[4],
                    border: `1px solid ${theme.palette.divider}`,
                    "&:hover": {
                      boxShadow: theme.shadows[8],
                      transform: "translateY(-2px)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  <CardContent sx={{ p: 4 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        mb: 3,
                      }}
                    >
                      <Typography variant="h6" fontWeight="bold">
                        {row.metal}
                      </Typography>
                      <Chip
                        size="small"
                        icon={getChangeIcon(row.change_percent)}
                        label={row.change_percent}
                        sx={{
                          backgroundColor: alpha(
                            getChangeColor(row.change_percent),
                            0.1
                          ),
                          color: getChangeColor(row.change_percent),
                          fontWeight: "bold",
                          border: `1px solid ${alpha(
                            getChangeColor(row.change_percent),
                            0.3
                          )}`,
                        }}
                      />
                    </Box>

                    <Grid container spacing={2} sx={{ mb: 2 }}>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="text.secondary">
                          Price
                        </Typography>
                        <Typography variant="h6" fontWeight="bold">
                          {row.price}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="text.secondary">
                          Volume
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">
                          {row.volume} Kg
                        </Typography>
                      </Grid>
                    </Grid>
                    <Box sx={{ mb: 3 }}>
                      <Typography variant="body2" color="text.secondary">
                        Market Cap
                      </Typography>
                      <Typography variant="body1" fontWeight="medium">
                        {row.market_cap}
                      </Typography>
                    </Box>

                    <Divider sx={{ mb: 2 }} />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )} */}
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            borderRadius: 3,
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: alpha(theme.palette.background.paper, 0.7),
          }}
        >
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: alpha(theme.palette.primary.main, 0.05),
                }}
              >
                {[
                  { field: "material", label: "Material" },
                  {
                    field: "price",
                    label: `Price (${filteredData[0]?.currency} / ${filteredData[0]?.unit})`,
                  },
                  { field: "change", label: "Change (%)" },
                  { field: "volume", label: "Volume" },
                  {
                    field: "marketCap",
                    label: `Market Cap (${filteredData[0]?.currency})`,
                  },
                ].map((column) => (
                  <TableCell
                    key={column.field}
                    sx={{
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "0.95rem",
                      "&:hover": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                      },
                    }}
                    onClick={() => handleSort(column.field)}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      {column.label}
                      {sortBy.field === column.field &&
                        (sortBy.direction === "asc" ? (
                          <ArrowUpward sx={{ fontSize: 18 }} />
                        ) : (
                          <ArrowDownward sx={{ fontSize: 18 }} />
                        ))}
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.length > 0 ? (
                paginatedData.map((row, i) => (
                  <TableRow
                    key={i}
                    sx={{
                      "&:hover": {
                        backgroundColor: alpha(theme.palette.action.hover, 0.5),
                      },
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    <TableCell sx={{ fontWeight: "medium", fontSize: "1rem" }}>
                      {row.metal}
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                      {row.price}
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        icon={getChangeIcon(row.change_percent)}
                        label={row.change_percent}
                        sx={{
                          backgroundColor: alpha(
                            getChangeColor(row.change_percent),
                            0.1
                          ),
                          color: getChangeColor(row.change_percent),
                          fontWeight: "bold",
                          border: `1px solid ${alpha(
                            getChangeColor(row.change_percent),
                            0.3
                          )}`,
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ color: "text.secondary" }}>
                      {row.volume}
                    </TableCell>
                    <TableCell sx={{ fontWeight: "medium" }}>
                      {row.market_cap}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={5}
                    sx={{
                      textAlign: "center",
                      py: 4,
                      color: theme.palette.text.secondary,
                      fontStyle: "italic",
                    }}
                  >
                    No market data available for this country.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <PaginationControls
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </Box>
      {/* Overlay CTA (if not logged in) */}
      {!isLoggedIn && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 2,
            backgroundColor: alpha(theme.palette.background.default, 0.6),
            borderRadius: 3,
          }}
        >
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
            Please log in to access live market data
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            {/* Log In Button */}
            <Button
              variant="contained"
              sx={{
                borderRadius: 2,
                px: 5,
                py: 1.5,
                backgroundColor: "#F4C542",
                color: "black",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#E3AE27", // slightly darker hover shade
                },
              }}
              onClick={handleLogin}
            >
              Login
            </Button>

            {/* Sign Up Button */}
            <Button
              variant="contained"
              sx={{
                borderRadius: 2,
                px: 5,
                py: 1.5,
                backgroundColor: (theme) => theme.palette.common.black,
                color: (theme) => theme.palette.common.white,
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: (theme) => theme.palette.grey[900],
                },
              }}
              onClick={handleRegister}
            >
              Register
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default OverviewTab;

{
  /* <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>
                  Actions
                </TableCell> */
}
{
  /* <TableCell>
                    <ButtonGroup variant="outlined" size="small">
                      <IconButton 
                        size="small" 
                        sx={{ 
                          border: `1px solid ${theme.palette.divider}`,
                          borderRadius: 1.5,
                          mr: 1,
                          '&:hover': { backgroundColor: alpha(theme.palette.warning.main, 0.1) }
                        }}
                      >
                        <StarBorder sx={{ fontSize: 18 }} />
                      </IconButton>
                      <IconButton 
                        size="small"
                        sx={{ 
                          border: `1px solid ${theme.palette.divider}`,
                          borderRadius: 1.5,
                          '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.1) }
                        }}
                      >
                        <AddShoppingCart sx={{ fontSize: 18 }} />
                      </IconButton>
                    </ButtonGroup>
                  </TableCell> */
}

{
  /* <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Button 
                        variant="outlined" 
                        fullWidth 
                        startIcon={<StarBorder />}
                        sx={{ borderRadius: 2 }}
                      >
                        Watch
                      </Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button 
                        variant="outlined" 
                        fullWidth 
                        startIcon={<AddShoppingCart />}
                        sx={{ borderRadius: 2 }}
                      >
                        Trade
                      </Button>
                    </Grid>
                  </Grid> */
}
